var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowW = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 8,
  viewBox: "0 0 10 8",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3.33 5h6.634V3H3.33l2.134-1.5V.992A.99.99 0 0 0 4.471 0h-.508L.31 3.321a.897.897 0 0 0 0 1.358L3.963 8h.508a.99.99 0 0 0 .993-.992V6.5z"
})));
export default SvgArrowW;